import React, { useState } from 'react';
import { compose, prop } from 'ramda';
import { withRGPortlet } from 'js/components/hocs/withRGPortlet';
import { componentService } from 'js/services/component.service';
import { usePortletSelector } from 'js/components/system/Portlet';

import { getProductLimits } from './actions';
import Product from './Product';
import reducer, { defaultState } from './reducer';
import { parseConfig } from './parse';
import { PRODUCT_BET_LIMITS, PRODUCT_LOSS_LIMITS } from './constants';

import style from './index.scss';

export const ProductLimitsBare = () => {
    const productLimits = usePortletSelector(prop('productLimits'));
    const { availableGroups } = usePortletSelector(prop('config'));
    const [editModeGroup, setEditMode] = useState(null);

    return (
        <div className={style.limitsHolder}>
            {availableGroups.map(name => (
                <Product key={name}
                    {...{
                        name,
                        limit: productLimits[name],
                        editMode: editModeGroup === name,
                        setEditMode
                    }}
                />
            ))}
        </div>
    );
};

export const isLimitEnabled = ({ limitEnabled, availableGroups = [] }) =>
    limitEnabled && availableGroups.filter(group => group.type === 'limit').length;

export const ProductLimits = compose(
    withRGPortlet({
        forLoggedIn: true,
        fetch: getProductLimits,
        reducer,
        initialValue: defaultState,
        isLimitEnabled,
        parseConfig
    })
)(ProductLimitsBare);

componentService.registerPageComponents({
    [PRODUCT_LOSS_LIMITS]: ProductLimits,
    [PRODUCT_BET_LIMITS]: ProductLimits
});
